export enum ClientSessionStageEnum {
  GUEST = "guest",
  IDENTIFIED = "identified",
  VERIFIED = "verified",
}

export type ClientSessionStageTypes = `${ClientSessionStageEnum}`;